import { GetPageByRouteQuery } from "apollo"
import { Culture, transformProperties } from "utils"
import SmartBlocksRenderer from "../Common/SmartBlocksRenderer"
import { mergeHeadquarterCareerBlocks } from "./mergeHeadquarterCareerBlocks"

type Props = {
  data: GetPageByRouteQuery
  locale: string
  culture: Culture
}

export default async function HeadquarterCareerPage({
  data,
  locale,
  culture,
}: Props): Promise<React.ReactElement> {
  const parsedData = data?.page?.properties || []
  const { blocks } = transformProperties(parsedData)
  const mergedBlocks = mergeHeadquarterCareerBlocks(blocks?.blocks || [])

  return (
    <SmartBlocksRenderer
      blocks={mergedBlocks}
      locale={locale}
      culture={culture}
      pageData={data}
    />
  )
}
